import { onCleanup, onMount } from 'solid-js';

const REDUCE = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export function useReveal() {
  onMount(() => {
    if (REDUCE() || !('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-reveal]').forEach((el) => {
        el.classList.add('is-visible');
      });
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    );

    const refresh = () => {
      document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach((el) => {
        io.observe(el);
      });
    };

    refresh();

    // MutationObserver на subtree body срабатывает на КАЖДОЕ изменение DOM
    // (включая reveal-классы, signal-обновления Solid). На iOS это давало
    // ощутимое замедление scroll'а. Батчим через rAF.
    let raf = 0;
    let pending = false;
    const mo = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      raf = requestAnimationFrame(() => {
        pending = false;
        refresh();
      });
    });
    mo.observe(document.body, { subtree: true, childList: true });

    onCleanup(() => {
      io.disconnect();
      mo.disconnect();
      if (raf) cancelAnimationFrame(raf);
    });
  });
}
